import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import emailjs from '@emailjs/browser'; 
import TopButton from './ScrollToTopButton';
import './styles/contato.css';

//service_zbe9ayo//


function Contato() {
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [telefone, setTelefone] = useState('');
    const [motivo, setMotivo] = useState('');
    const [mensagem, setMensagem] = useState('');

    const handleTelefoneChange = (e) => {
        const value = e.target.value
            .replace(/\D/g, '') // Remove caracteres não numéricos
            .substring(0, 11); // Limita a 11 dígitos

        if (value.length <= 2) {
            e.target.value = `(${value}`;
        } else if (value.length <= 7) {
            e.target.value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
        } else {
            e.target.value = `(${value.substring(0, 2)}) ${value.substring(2, 7)}-${value.substring(7)}`;
        }

        setTelefone(e.target.value);
    };

    const sendEmail = (e) => {
        e.preventDefault();

        if (nome === '' || email === '' || empresa === '' || telefone === '' || mensagem === '') {
            alert('Preencha todos os campos!');
            return;
        }

        const templateParams = {
            nome,
            email,
            empresa,
            telefone,
            motivo,
            mensagem,
        };

        emailjs.send('service_bccy609', 'template_wd0mi38', templateParams, 'LtQ4uc4iw52-lQIGU')
            .then((response) => {
                console.log('E-mail enviado com sucesso!', response.status, response.text);
                alert(`Recebemos sua mensagem, ${nome}`);
            }, (error) => {
                console.error('Erro ao enviar o e-mail:', error);
                alert('Erro ao enviar o e-mail, tente novamente.');
            });

        // Limpar os campos após o envio
        setNome('');
        setEmail('');
        setEmpresa('');
        setTelefone('');
        setMotivo('');
        setMensagem('');
    };

    const animationProps = useSpring({
        from: { transform: 'translateY(100%)', opacity: 0 },
        to: { transform: 'translateY(0)', opacity: 1 },
        config: { tension: 150, friction: 20 }
    });

    return (
        <div className="home">
            <animated.div style={animationProps} className='welcomeCard'>
                <div className="cardContainer">
                    <div className="card">
                        <h1>Fale conosco</h1>
                        <form onSubmit={sendEmail}>
                            <input
                                type="text"
                                placeholder="Nome completo"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                required
                            />
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <input
                                type="text"
                                placeholder="Empresa"
                                value={empresa}
                                onChange={(e) => setEmpresa(e.target.value)}
                                required
                            />
                            <input
                                type="text"
                                placeholder="Telefone"
                                value={telefone}
                                onChange={handleTelefoneChange}
                                required
                            />
                            <input
                                type="text"
                                placeholder="Motivo do contato"
                                value={motivo}
                                onChange={(e) => setMotivo(e.target.value)}
                            />
                            <textarea
                                placeholder="Mensagem"
                                value={mensagem}
                                onChange={(e) => setMensagem(e.target.value)}
                                required
                            />
                            <button className="buttonSubmit" type="submit">Enviar</button>
                        </form>
                    </div>
                </div>
            </animated.div>
            <TopButton />
        </div>
    );
}

export default Contato;
